import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "sweetalert2/dist/sweetalert2.min.css";
import InitLocale from "./locales/_core/initLocale";
import App from "./router/App";
import Parse from "parse";
import { PARSE_APP_ID, PARSE_JS_KEY, PARSE_URL } from "./config/env";
import { registerSW } from "virtual:pwa-register";

// Register PWA
registerSW({});

// Init Parse Server
Parse.initialize(PARSE_APP_ID, PARSE_JS_KEY);
Parse.serverURL = PARSE_URL;

// Init React
const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <InitLocale>
            <App />
        </InitLocale>
    </React.StrictMode>
);
